import prettyBytes from 'pretty-bytes';

export function formatBytes(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) return '—';
    return prettyBytes(value);
}

export function formatMemory(mb: number): string {
    return mb >= 1024 ? `${mb / 1024} GB` : `${mb} MB`;
}

export function formatBandwidth(gb: number | undefined | null): string {
    if (gb === undefined || gb === null || isNaN(gb)) return '—';
    if (gb >= 1024) return `${(gb / 1024).toFixed(2)} TB`;
    return `${gb.toFixed(2)} GB`;
}

export function bandwidthPercent(usage: number, limit: number): number {
    if (!limit || limit <= 0) return 0;
    return Math.min(100, (usage / limit) * 100);
}
